// source: starlord/messages/response/application_response.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var starlord_messages_models_application_details_pb = require('../../../starlord/messages/models/application_details_pb.js');
goog.object.extend(proto, starlord_messages_models_application_details_pb);
goog.exportSymbol('proto.ApplicationResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ApplicationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ApplicationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ApplicationResponse.displayName = 'proto.ApplicationResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ApplicationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ApplicationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ApplicationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ApplicationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationdetails: (f = msg.getApplicationdetails()) && starlord_messages_models_application_details_pb.ApplicationDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ApplicationResponse}
 */
proto.ApplicationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ApplicationResponse;
  return proto.ApplicationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ApplicationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ApplicationResponse}
 */
proto.ApplicationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new starlord_messages_models_application_details_pb.ApplicationDetails;
      reader.readMessage(value,starlord_messages_models_application_details_pb.ApplicationDetails.deserializeBinaryFromReader);
      msg.setApplicationdetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ApplicationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ApplicationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ApplicationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ApplicationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationdetails();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      starlord_messages_models_application_details_pb.ApplicationDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional ApplicationDetails applicationDetails = 1;
 * @return {?proto.ApplicationDetails}
 */
proto.ApplicationResponse.prototype.getApplicationdetails = function() {
  return /** @type{?proto.ApplicationDetails} */ (
    jspb.Message.getWrapperField(this, starlord_messages_models_application_details_pb.ApplicationDetails, 1));
};


/**
 * @param {?proto.ApplicationDetails|undefined} value
 * @return {!proto.ApplicationResponse} returns this
*/
proto.ApplicationResponse.prototype.setApplicationdetails = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ApplicationResponse} returns this
 */
proto.ApplicationResponse.prototype.clearApplicationdetails = function() {
  return this.setApplicationdetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ApplicationResponse.prototype.hasApplicationdetails = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto);
